import { supabase } from "@/integrations/supabase/client";

/** How many people liked each of these posts. */
export const getSocialLikeCounts = async (postIds: string[]): Promise<Map<string, number>> => {
  const counts = new Map<string, number>();
  if (postIds.length === 0) return counts;
  const { data, error } = await supabase
    .from("social_post_likes")
    .select("post_id")
    .in("post_id", postIds);
  if (error) throw error;
  for (const row of data ?? []) {
    counts.set(row.post_id, (counts.get(row.post_id) ?? 0) + 1);
  }
  return counts;
};

/** Posts this member has already liked. */
export const getMySocialLikes = async (userId: string): Promise<string[]> => {
  const { data, error } = await supabase
    .from("social_post_likes")
    .select("post_id")
    .eq("user_id", userId);
  if (error) throw error;
  return (data ?? []).map((r) => r.post_id);
};

export const likeSocialPost = async (postId: string, userId: string): Promise<void> => {
  const { error } = await supabase
    .from("social_post_likes")
    .insert({ post_id: postId, user_id: userId });
  // Ignore duplicates: the like already exists.
  if (error && error.code !== "23505") throw error;
};

export const unlikeSocialPost = async (postId: string, userId: string): Promise<void> => {
  const { error } = await supabase
    .from("social_post_likes")
    .delete()
    .eq("post_id", postId)
    .eq("user_id", userId);
  if (error) throw error;
};
